(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-updates-timeline"] && !Shopify.designMode) return;
  try {
    
  class MirockRecentUpdatesTimeline extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.scroller = this.querySelector('[data-timeline-scroller]');
      this.previousButton = this.querySelector('[data-timeline-previous]');
      this.nextButton = this.querySelector('[data-timeline-next]');

      if (!this.scroller || !this.previousButton || !this.nextButton) return;

      this.isInitialized = true;
      this.handlePrevious = () => this.scrollByCard(-1);
      this.handleNext = () => this.scrollByCard(1);
      this.handleScroll = () => this.updateControls();

      this.previousButton.addEventListener('click', this.handlePrevious);
      this.nextButton.addEventListener('click', this.handleNext);
      this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.scroller);
      this.updateControls();
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      this.previousButton.removeEventListener('click', this.handlePrevious);
      this.nextButton.removeEventListener('click', this.handleNext);
      this.scroller.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
      this.isInitialized = false;
    }

    scrollByCard(direction) {
      const card = this.querySelector('.recent-updates-timeline__entry');
      const track = this.querySelector('.recent-updates-timeline__track');
      if (!card || !track) return;

      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
      const distance = card.getBoundingClientRect().width + gap;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      this.scroller.scrollBy({ left: distance * direction, behavior });
    }

    updateControls() {
      const header = this.querySelector('.recent-updates-timeline__header');
      if (header) {
        const contentOffset = Math.max(0, header.getBoundingClientRect().left - this.getBoundingClientRect().left);
        this.style.setProperty('--recent-updates-content-offset', `${contentOffset}px`);
      }

      const maximumScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      this.previousButton.disabled = this.scroller.scrollLeft <= 2;
      this.nextButton.disabled = this.scroller.scrollLeft >= maximumScroll - 2;
    }
  }

  if (!customElements.get('recent-updates-timeline')) {
    customElements.define('recent-updates-timeline', MirockRecentUpdatesTimeline);
  }

  } catch(e) { console.error(e); }
})();
})();
